<template>
<v-text-field outlined v-model="sensitivity" :rules="rules" :label="$t('configurations.report_sensitivity')"></v-text-field>
</template>

<script>
export default {
  name: 'ReportSensitivityTextField',
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      range: [0.1, 50],
      rules: [
        v => !!v || this.$t('configurations.this_is_required'),
        v => parseFloat(v) <= this.range[1] || this.$t('configurations.max_is', {
          val: this.range[1]
        }),
        v => parseFloat(v) >= this.range[0] || this.$t('configurations.min_is', {
          val: this.range[0]
        })
      ]
    }
  },
  computed: {
    sensitivity: {
      get() {
        return this.value || '';
      },
      set(val) {
        this.$emit('input', parseFloat(val));
      }
    }
  }
}
</script>
